import { render, staticRenderFns } from "./GoodsSkuList.vue?vue&type=template&id=343412af&scoped=true&"
import script from "./GoodsSkuList.vue?vue&type=script&lang=js&"
export * from "./GoodsSkuList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSkuList.vue?vue&type=style&index=0&id=343412af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343412af",
  null
  
)

export default component.exports